import React from 'react';

export const NotFoundImg = () => (
	<svg
		width="288"
		height="191"
		viewBox="0 0 288 191"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		data-qa="not-found-img"
	>
		<mask id="path-1-inside-1_5324_101087" fill="white">
			<path d="M114.065 53.4797C109.777 37.4757 119.275 21.0256 135.279 16.7374C151.283 12.4491 167.733 21.9466 172.021 37.9506L114.065 53.4797Z" />
		</mask>
		<path
			d="M114.065 53.4797C109.777 37.4757 119.275 21.0256 135.279 16.7374C151.283 12.4491 167.733 21.9466 172.021 37.9506L114.065 53.4797Z"
			fill="white"
		/>
		<path
			d="M172.021 37.9506L171.244 35.0528L113.289 50.582L114.065 53.4797L114.842 56.3775L172.797 40.8484L172.021 37.9506ZM135.279 16.7374L136.055 19.6352C150.459 15.7757 165.264 24.3235 169.123 38.727L172.021 37.9506L174.919 37.1741C170.202 19.5697 152.106 9.12253 134.502 13.8396L135.279 16.7374ZM135.279 16.7374L134.502 13.8396C116.898 18.5567 106.45 36.6518 111.168 54.2562L114.065 53.4797L116.963 52.7033C113.104 38.2997 121.651 23.4946 136.055 19.6352L135.279 16.7374Z"
			fill="#21282B"
			mask="url(#path-1-inside-1_5324_101087)"
		/>
		<path
			d="M114.252 50.8125C128.257 34.9046 150.444 28.96 170.526 35.734L201.869 48.9349C203.719 49.714 205.105 51.3046 205.625 53.2434L205.892 54.2386C206.821 57.7061 204.763 61.2703 201.295 62.1994L100.839 89.1166C97.3716 90.0457 93.8074 87.988 92.8783 84.5204L92.6117 83.5253C92.0921 81.5864 92.4975 79.5157 93.71 77.9161L114.252 50.8125Z"
			fill="#B8CAC4"
			stroke="#21282B"
			strokeWidth="3"
		/>
		<path
			d="M144.145 49.8201C160.011 45.5687 174.999 44.3125 186.379 45.6696C192.073 46.3487 196.784 47.6734 200.237 49.5407C203.687 51.4061 205.758 53.7385 206.475 56.4126C207.191 59.0866 206.564 62.142 204.509 65.4823C202.452 68.8262 199.034 72.3291 194.442 75.7642C185.266 82.6292 171.658 89.0353 155.791 93.2868C139.925 97.5383 124.937 98.7945 113.557 97.4373C107.863 96.7582 103.152 95.4336 99.6985 93.5662C96.2489 91.7008 94.1778 89.3684 93.4613 86.6944C92.7448 84.0204 93.3722 80.9649 95.427 77.6246C97.4841 74.2807 100.902 70.7778 105.494 67.3427C114.67 60.4777 128.278 54.0716 144.145 49.8201Z"
			fill="#B8CAC4"
			stroke="#21282B"
			strokeWidth="3"
		/>
		<path
			d="M152.169 79.7643C159.812 77.7163 166.909 76.7324 172.184 76.7712C174.832 76.7907 176.932 77.0684 178.389 77.545C179.918 78.0451 180.332 78.6178 180.414 78.9253C180.521 79.3223 180.613 80.0453 180.677 81.0053C180.74 81.9341 180.77 82.9878 180.783 83.9877C180.795 84.9757 180.791 85.8991 180.782 86.5802L130.539 99.5454C130.279 99.1987 129.95 98.7374 129.597 98.1861C128.754 96.8687 127.806 95.0911 127.288 93.1604C127.206 92.8528 127.278 92.1501 128.352 90.9525C129.375 89.8112 131.056 88.5205 133.339 87.1796C137.887 84.5087 144.526 81.8124 152.169 79.7643Z"
			fill="#B8CAC4"
			stroke="#21282B"
			strokeWidth="3"
		/>
		<path
			d="M154.437 88.2362C161.54 86.333 168.144 85.4795 173.057 85.6086C175.524 85.6734 177.476 85.9839 178.83 86.477C180.233 86.9878 180.655 87.5586 180.75 87.9148C180.846 88.271 180.766 88.9764 179.807 90.12C178.881 91.224 177.345 92.4691 175.241 93.7586C171.05 96.3271 164.904 98.89 157.802 100.793C150.699 102.696 144.095 103.55 139.181 103.421C136.715 103.356 134.762 103.045 133.408 102.552C132.006 102.042 131.584 101.471 131.488 101.115C131.393 100.758 131.473 100.053 132.432 98.9094C133.358 97.8054 134.894 96.5603 136.997 95.2708C141.188 92.7023 147.334 90.1393 154.437 88.2362Z"
			fill="#FDC300"
			stroke="#21282B"
			strokeWidth="3"
		/>
		<g clipPath="url(#clip0_5324_101087)">
			<g clipPath="url(#clip1_5324_101087)">
				<path d="M212 180L177 180L177 71L212 180Z" fill="#FDC300" />
				<rect
					width="109"
					height="47"
					transform="matrix(-1.19249e-08 -1 -1 1.19249e-08 177 180)"
					fill="#FDC300"
				/>
			</g>
		</g>
		<path
			d="M152.169 79.7643C159.812 77.7163 166.909 76.7324 172.184 76.7712C174.832 76.7907 176.932 77.0684 178.389 77.545C179.918 78.0451 180.332 78.6178 180.414 78.9253C180.521 79.3223 180.613 80.0453 180.677 81.0053C180.74 81.9341 180.77 82.9878 180.783 83.9877C180.795 84.9757 180.791 85.8991 180.782 86.5802L130.539 99.5454C130.279 99.1987 129.95 98.7374 129.597 98.1861C128.754 96.8687 127.806 95.0911 127.288 93.1604C127.206 92.8528 127.278 92.1501 128.352 90.9525C129.375 89.8112 131.056 88.5205 133.339 87.1796C137.887 84.5087 144.526 81.8124 152.169 79.7643Z"
			fill="white"
			stroke="#21282B"
			strokeWidth="3"
		/>
		<path
			d="M154.437 88.2362C161.54 86.333 168.144 85.4795 173.057 85.6086C175.524 85.6734 177.476 85.9839 178.83 86.477C180.233 86.9878 180.655 87.5586 180.75 87.9148C180.846 88.271 180.766 88.9764 179.807 90.12C178.881 91.224 177.345 92.4691 175.241 93.7586C171.05 96.3271 164.904 98.89 157.802 100.793C150.699 102.696 144.095 103.55 139.181 103.421C136.715 103.356 134.762 103.045 133.408 102.552C132.006 102.042 131.584 101.471 131.488 101.115C131.393 100.758 131.473 100.053 132.432 98.9094C133.358 97.8054 134.894 96.5603 136.997 95.2708C141.188 92.7023 147.334 90.1393 154.437 88.2362Z"
			fill="#FDC300"
			stroke="#21282B"
			strokeWidth="3"
		/>
		<mask id="path-11-inside-2_5324_101087" fill="white">
			<rect x="51" y="135" width="48" height="48" rx="2" />
		</mask>
		<rect x="51" y="135" width="48" height="48" rx="2" fill="white" />
		<rect
			x="51"
			y="135"
			width="48"
			height="48"
			rx="2"
			stroke="#21282B"
			strokeWidth="6"
			strokeLinejoin="round"
			mask="url(#path-11-inside-2_5324_101087)"
		/>
		<path
			d="M81.5 136.5V149C81.5 149.276 81.2761 149.5 81 149.5H69C68.7239 149.5 68.5 149.276 68.5 149V136.5H81.5Z"
			fill="white"
			stroke="#21282B"
			strokeWidth="3"
			strokeLinejoin="round"
		/>
		<path
			d="M36 181.5H252"
			stroke="#21282B"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<defs>
			<clipPath id="clip0_5324_101087">
				<rect width="82" height="93" fill="white" transform="translate(130 87)" />
			</clipPath>
			<clipPath id="clip1_5324_101087">
				<rect
					width="109"
					height="82"
					fill="white"
					transform="matrix(-1.19249e-08 -1 -1 1.19249e-08 212 180)"
				/>
			</clipPath>
		</defs>
	</svg>
);
